
export function getUAPlatform() {
  let p = navigator.userAgentData?.platform;
  if (p)
    return p;
  let p1 = navigator.platform || '';
  if (p1.startsWith('Win')) {
    p = 'Windows';
  } else if (p1 === 'MacIntel') {
    p = 'macOS';
  } else if (p1.startsWith('Linux')) {
    let p2 = navigator.userAgent.match(/\(([^)]+)\)?/)?.[1] || '';
    if ((/Android (\d+(\.\d+)*)/.exec(p2)) !== null) {
      p = 'Android';
    } else if ((/CrOS (\w+) (\d+(\.\d+)*)/.exec(p2)) !== null) {
      p = 'Chrome OS';
    } else {
      p = 'Linux';
    }
  } else if (/^(?:iPhone|iPad|iPod)/.test(p1)) {
    p = 'iOS';
  } else {
    p = 'Unknown';
  }
  return p;
}

export function getUABrand() {
  let ua = navigator.userAgent;
  let b = '';
  let m;
  if ((m = ua.match(/(Chrome|Firefox)\/(\d+)/))) {
    b = m[1];
  } else if ((m = ua.match(/(Version)\/(\d+\.\d+) (?:Safari|Mobile)/))) {
    b = 'Safari';
  } else if ((m = ua.match(/(AppleWebKit)\/(\d+\.\d+)/)) && m[2] === '605.1') {
    b = 'Safari';
  }
  return b;
}

export function dynamicImport(href, attributes = null) {
  let w = attributes.with;
  if (!w || !['json', 'css'].includes(w.type)) {
    throw new Error('dynamicImport() can only be used to import json and css');
  }
  let url = new URL(href, import.meta.url).href;
  if (w.type === 'json') {
    return fetch(url, {
      headers: {
        accept: 'application/json,*;q=0.5'
      },
      mode: 'cors',
      destination: 'json',
    }).then((r) => {
      if (r.ok) {
        let type = r.headers['content-type'];
        if (/^application\/json/.test(type))
          throw new Error(`Unexpected content-type ${type} responded from server`);
        return r.json().then((v) => {
          return {default: v, [Symbol.toString]: 'Module'};
        });
      }
      throw new Error(`Error loading ${url}, status code ${r.status}`);
    });
  } else {
    return fetch(url, {
      headers: {
        accept: 'text/css,*;q=0.5'
      },
      mode: 'cors',
      destination: 'style',
    }).then((r) => {
      if (r.ok) {
        let type = r.headers['content-type'];
        if (/^text\/css/.test(type))
          throw new Error(`Unexpected content-type ${type} responded from server`);
        return r.text().then((text) => {
          let sheet = new CSSStyleSheet();
          sheet.replaceSync(text);
          return {default: sheet, [Symbol.toString]: 'Module'};
        });
      }
      throw new Error(`Error loading ${url}, status code ${r.status}`);
    });
  }
}
